import { MENTIONS_VIEW_PAGE_SIZE } from "@/constants";
/**
 * Simple helper to find out on which page a mention is in a paginated response
 *
 * @param index the index of a mention in a paginated list
 * @param pageSize page size of the paginated response
 * @returns the page number that the mention is on
 */
const pageFromFeedIndex = (
  index: number,
  pageSize = MENTIONS_VIEW_PAGE_SIZE
) => {
  // calculate the page, and round upwards since page counts are not zero-indexed
  const page = Math.floor(index / pageSize) + 1;
  const actualPage = page === 1 ? undefined : page;
  return actualPage;
};

export default pageFromFeedIndex;
